import { useQuery } from "@tanstack/react-query";
import { http } from "@/lib/api";

export const useMenu = () =>
  useQuery({
    queryKey: ["menu"],
    queryFn: async () => (await http.get("/menu")).data,
    staleTime: 15_000,
    refetchOnWindowFocus: true,
  });
